// import './App.css';
import Menubar from './components/Menubar';
import Prefooter from './components/Prefooter';
import Footer from './components/Footer';
import Header from './Pages/Home/Header';
import EllipseComponent from './components/Solutions';

function App() {
  return (
    <div className="App">
      <Menubar />
      <Header />
      <EllipseComponent />
      <Prefooter />
      <Footer />
    </div>
  );
}

export default App;
